const ChatReplyMessageType = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41"
      height="41"
      viewBox="0 0 41 41"
    >
      <desc>채팅 답글 알림</desc>
      <defs>
        <clipPath id="g0q1958yea">
          <path
            fill="#fff"
            stroke="#707070"
            strokeWidth="1.5"
            d="M379 637.164h20v20h-20z"
            data-name="사각형 21620"
          ></path>
        </clipPath>
      </defs>
      <g data-name="구성 요소 292 – 114">
        <g data-name="그룹 29886">
          <path
            fill="#fff"
            stroke="#eee"
            d="M20.5.5a20 20 0 11-20 20 20 20 0 0120-20z"
            data-name="패스 12611"
          ></path>
          <g
            clipPath="url(#g0q1958yea)"
            data-name="마스크 그룹 4534"
            transform="translate(-368.5 -626.664)"
          >
            <g data-name="그룹 29884">
              <g data-name="그룹 29883">
                <g data-name="그룹 29877">
                  <g data-name="그룹 29876">
                    <g fill="#01a0ff" data-name="합치기 222">
                      <path d="M386.976 652.084a6.305 6.305 0 01-3.966-1.383l-.272-.217-.342.068-1.34.267a.249.249 0 01-.246-.091.241.241 0 01-.046-.212l.417-1.77.057-.244-.1-.23a6.38 6.38 0 015.837-8.934 6.38 6.38 0 016.373 6.374 6.38 6.38 0 01-6.373 6.372z"></path>
                      <path d="M386.976 651.334a5.63 5.63 0 005.623-5.622 5.63 5.63 0 00-5.623-5.624 5.63 5.63 0 00-5.152 7.882l.202.46-.354 1.501 1.26-.25.545.433a5.563 5.563 0 003.499 1.22m0 1.5a7.093 7.093 0 01-4.434-1.546l-1.341.267a1 1 0 01-1.168-1.21l.417-1.77a7.123 7.123 0 116.525 4.26z"></path>
                    </g>
                  </g>
                  <path
                    fill="none"
                    stroke="#01a0ff"
                    strokeLinecap="round"
                    strokeWidth="1.5"
                    d="M383.923 645.451h6.106"
                    data-name="선 2044"
                  ></path>
                  <path
                    fill="none"
                    stroke="#01a0ff"
                    strokeLinecap="round"
                    strokeWidth="1.5"
                    d="M383.923 647.486h4.071"
                    data-name="선 2045"
                  ></path>
                </g>
                <g data-name="그룹 29882">
                  <g data-name="그룹 29879">
                    <g data-name="그룹 29878">
                      <g fill="#fff" data-name="합치기 223">
                        <path d="M390.507 655.269a6.93 6.93 0 01-6.922-6.921 6.929 6.929 0 016.922-6.921 6.929 6.929 0 016.921 6.92c0 1.17-.297 2.326-.858 3.342l-.147.265.079.292.73 2.721a.146.146 0 01-.025.133.123.123 0 01-.094.052c-.007 0-.015 0-.023-.002l-3.155-.523a.15.15 0 01-.023-.006l-.277-.09-.265.12a6.863 6.863 0 01-2.862.618z"></path>
                        <path d="M390.507 642.177a6.178 6.178 0 00-6.172 6.17 6.179 6.179 0 008.723 5.622l.531-.241.511.166 2.164.359-.643-2.397.292-.53a6.174 6.174 0 00-5.406-9.149m0-1.5a7.672 7.672 0 016.72 11.375l.73 2.72c.168.628-.358 1.223-.99 1.118l-3.156-.523a.9.9 0 01-.132-.032 7.671 7.671 0 11-3.172-14.658z"></path>
                      </g>
                    </g>
                    <path
                      fill="none"
                      stroke="#fff"
                      strokeLinecap="round"
                      strokeWidth="1.5"
                      d="M387.037 647.163h6.303"
                      data-name="선 2046"
                    ></path>
                    <path
                      fill="none"
                      stroke="#fff"
                      strokeLinecap="round"
                      strokeWidth="1.5"
                      d="M387.037 649.297h4.202"
                      data-name="선 2047"
                    ></path>
                  </g>
                  <g data-name="그룹 29881">
                    <g data-name="그룹 29880">
                      <g fill="#01a0ff" data-name="합치기 224">
                        <path d="M391.408 655.231a6.38 6.38 0 01-6.374-6.373 6.38 6.38 0 016.374-6.374 6.38 6.38 0 016.373 6.374 6.368 6.368 0 01-.862 3.202l-.158.272.083.303.46 1.684a.24.24 0 01-.042.216.249.249 0 01-.24.096l-1.97-.32-.263-.044-.23.132a6.372 6.372 0 01-3.151.832z"></path>
                        <path d="M391.408 643.234a5.63 5.63 0 00-5.624 5.624 5.63 5.63 0 005.624 5.623 5.62 5.62 0 002.78-.734l.46-.263 1.727.282-.42-1.54.316-.543a5.62 5.62 0 00.76-2.825 5.63 5.63 0 00-5.623-5.624m0-1.5a7.123 7.123 0 016.16 10.704l.459 1.684a1 1 0 01-1.126 1.25l-1.97-.322a7.124 7.124 0 11-3.523-13.316z"></path>
                      </g>
                    </g>
                    <text
                      fill="#fff"
                      fontFamily="Cafe24Ssurround,Cafe24 Ssurround"
                      fontSize="9"
                      letterSpacing="-.04em"
                      transform="translate(391.5 651.164)"
                    >
                      <tspan x="-3.033" y="0">
                        A
                      </tspan>
                    </text>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default ChatReplyMessageType
